import * as Sentry from '@sentry/browser'
import React from 'react'
import { ErrorView } from './ErrorView'

interface FlashErrorState {
  eventId: string | null
  hasError: boolean
  error?: string
}

/**
 * A simple error boundary class that will also log the error
 * and pass it along to sentry.
 */
export class FlashError extends React.Component<any, FlashErrorState> {
  public static getDerivedStateFromError(error: Error) {
    console.log(error)
    return { hasError: true, error: error.message }
  }

  constructor(props: any) {
    super(props)
    this.state = { eventId: null, hasError: false }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Sentry.withScope((scope) => {
    //   scope.setExtras(errorInfo as any)
    //   const eventId = Sentry.captureException(error)
    //   this.setState({ eventId })
    // })
  }

  public render() {
    return this.state.hasError ? (
      <ErrorView error={this.state.error} />
    ) : (
      this.props.children
    )
  }
}
